var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"content-slide-layout-item"},_vm.$listeners),[_c('div',{staticClass:"layout-thumbnail-image"},[_c('img',{attrs:{"src":_vm.layout.layoutThumbnailImage}})]),_c('p',{staticClass:"layout-name"},[_vm._v("\n    "+_vm._s(_vm.layout.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }